import moment from 'moment-timezone'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '@src/const'

export function getProcedimientos(procedimientos, fechaAplicacionEvaluacion) {
  const minDate = moment(fechaAplicacionEvaluacion, VUETIFY_DATE_FORMAT).subtract(3, 'year')
  const maxDate = moment(fechaAplicacionEvaluacion, VUETIFY_DATE_FORMAT)

  return procedimientos.filter(({ fecha }) => {
    const fechaProcedimiento = moment(fecha, API_DATE_FORMAT).format(VUETIFY_DATE_FORMAT)
    return moment(fechaProcedimiento).isBetween(minDate, maxDate)
  })
}
